var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarbonNeutral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "49px",
    viewBox: "0 0 48 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NET ZERO") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NET-ZERO",
    transform: "translate(1.000000, 1.338422)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#000000",
    strokeWidth: 1.5,
    cx: 23,
    cy: 23,
    r: 23
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(8.000000, 13.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.956,11.844 C28.416,11.844 30.264,13.752 30.264,16.2 C30.264,18.66 28.404,20.556 25.944,20.556 C23.484,20.556 21.636,18.684 21.636,16.2 C21.636,13.728 23.496,11.844 25.956,11.844 Z M6.312,12 L6.312,13.644 L1.152,19.212 L1.152,19.308 L6.336,19.308 L6.336,20.4 L0,20.4 L0,18.768 L5.148,13.2 L5.148,13.104 L0.144,13.104 L0.144,12 L6.312,12 Z M13.008,12 L13.008,13.128 L9.288,13.128 L9.288,15.564 L12.492,15.564 L12.492,16.68 L9.288,16.68 L9.288,19.272 L13.128,19.272 L13.128,20.4 L8.064,20.4 L8.064,12 L13.008,12 Z M17.544,12 C19.272,12 20.352,13.008 20.352,14.508 C20.352,15.72 19.704,16.68 18.48,16.98 L18.48,16.98 L20.652,20.4 L19.188,20.4 L17.232,17.112 L16.032,17.112 L16.032,20.4 L14.808,20.4 L14.808,12 Z M25.956,13.008 C24.216,13.008 22.908,14.376 22.908,16.2 C22.908,18.048 24.216,19.392 25.956,19.392 C27.684,19.392 29.004,18.048 29.004,16.2 C29.004,14.376 27.684,13.008 25.956,13.008 Z M17.484,13.116 L16.032,13.116 L16.032,16.02 L17.544,16.02 C18.432,16.02 19.092,15.504 19.092,14.52 C19.092,13.74 18.564,13.116 17.484,13.116 L17.484,13.116 Z M7.128,0 L10.368,7.236 L10.452,7.236 L10.452,0 L11.652,0 L11.652,8.4 L9.588,8.4 L6.396,1.164 L6.312,1.164 L6.312,8.4 L5.088,8.4 L5.088,0 L7.128,0 Z M18.804,0 L18.804,1.128 L15.084,1.128 L15.084,3.564 L18.288,3.564 L18.288,4.68 L15.084,4.68 L15.084,7.272 L18.924,7.272 L18.924,8.4 L13.86,8.4 L13.86,0 L18.804,0 Z M25.848,0 L25.848,1.128 L23.46,1.128 L23.46,8.4 L22.248,8.4 L22.248,1.128 L19.86,1.128 L19.86,0 L25.848,0 Z",
    id: "Combined-Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonNeutral);
export default __webpack_public_path__ + "static/media/carbonNeutral.6a3b2534e87ca690fbec02d36bed9b4a.svg";
export { ForwardRef as ReactComponent };